import * as React from 'react';

function SvgComponent(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg viewBox="0 0 500 628" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        className="animate-loader-1100"
        d="M374.3 564.9c-5.1 0-10.2-2.4-13.3-7L234.1 373.2c-5-7.3-3.2-17.4 4.2-22.4 7.3-5 17.4-3.2 22.4 4.2l126.9 184.7c5 7.3 3.2 17.4-4.2 22.4-2.8 1.9-5.9 2.8-9.1 2.8z"
        fill="#007379"
      />
      <path
        className="animate-loader-1000"
        d="M483.9 387.8c-1.6 0-3.2-.3-4.9-.8l-205-68.5c-8-2.7-12.4-11.4-9.7-19.4 2.7-8 11.4-12.4 19.4-9.7l205 68.5c8 2.7 12.4 11.4 9.7 19.4-2.1 6.5-8 10.5-14.5 10.5z"
        fill="#00837F"
      />
      <path
        className="animate-loader-900"
        d="M295 247.7c-6.9 0-13-4.9-14.3-12-1.4-7.9 3.9-15.4 11.8-16.8l173-30.7c7.9-1.4 15.4 3.9 16.8 11.8 1.4 7.9-3.9 15.4-11.8 16.8l-173 30.7c-.8.1-1.7.2-2.5.2z"
        fill="#009383"
      />
      <path
        className="animate-loader-800"
        d="M271.1 187.1c-2.7 0-5.5-.8-7.9-2.5-6.2-4.4-7.7-12.9-3.3-19.1l81.3-115.1c4.4-6.2 12.9-7.7 19.1-3.3 6.2 4.4 7.7 12.9 3.3 19.1l-81.3 115.1c-2.7 3.8-6.9 5.8-11.2 5.8z"
        fill="#00A584"
      />
      <path
        className="animate-loader-700"
        d="M212.1 147.4c-6.7 0-12.6-5-13.6-11.8l-16.6-119c-1-7.5 4.2-14.4 11.7-15.5 7.5-1.1 14.4 4.2 15.5 11.7l16.6 118.9c1 7.5-4.2 14.4-11.7 15.5-.6.1-1.2.2-1.9.2z"
        fill="#1DAA72"
      />
      <path
        className="animate-loader-600"
        d="M142.6 147.5c-3.6 0-7.2-1.5-9.8-4.5L64.3 63.8c-4.7-5.4-4.1-13.5 1.3-18.2 5.4-4.7 13.5-4.1 18.2 1.3l68.5 79.2c4.7 5.4 4.1 13.5-1.3 18.2-2.4 2.2-5.4 3.2-8.4 3.2z"
        fill="#51B05C"
      />
      <path
        className="animate-loader-500"
        d="M13 199c-5.9 0-11.1-4.3-12-10.3-1-6.6 3.6-12.8 10.2-13.7l92.4-13.6c6.6-1 12.8 3.6 13.7 10.2.9 6.6-3.6 12.8-10.2 13.7l-92.4 13.6c-.5.1-1.1.1-1.7.1z"
        fill="#70B644"
      />
      <path
        className="animate-loader-400"
        d="M56.9 308.7c-2.4 0-4.9-.8-6.9-2.4-4.9-3.8-5.8-10.9-2-15.9l53.4-68.7c3.8-4.9 10.9-5.8 15.9-2 4.9 3.8 5.8 10.9 2 15.9l-53.4 68.7c-2.3 2.9-5.6 4.4-9 4.4z"
        fill="#88BC24"
      />
      <path
        className="animate-loader-300"
        d="M146.1 344.4c-5.4.3-10.2-3.7-10.9-9.2l-8.1-65.9c-.7-5.8 3.4-11 9.1-11.7 5.7-.7 11 3.4 11.7 9.1l8.1 65.9c.7 5.8-3.4 11-9.1 11.7-.3 0-.6.1-.8.1z"
        fill="#9AC11B"
      />
      <path
        className="animate-loader-200"
        d="M218.6 313.1c-2.5.3-5.1-.3-7.3-2l-34.9-27.6c-4.2-3.3-4.9-9.4-1.6-13.6 3.3-4.2 9.4-4.9 13.6-1.6l34.9 27.6c4.2 3.3 4.9 9.4 1.6 13.6-1.6 2.1-3.9 3.3-6.3 3.6z"
        fill="#ABC70C"
      />
      <path
        className="animate-loader-100"
        d="M203.9 251.3c-3.6.6-7.4-1.1-9.3-4.5-2.3-4.3-.7-9.7 3.6-12l19.2-10.4c4.3-2.3 9.7-.7 12 3.6 2.3 4.3.7 9.7-3.6 12l-19.2 10.4c-.8.5-1.8.8-2.7.9z"
        fill="#BC0"
      />
      <circle
        className="animate-loader"
        fill="#CAD100"
        cx={185.5}
        cy={211}
        r={9.7}
      />
    </svg>
  );
}

export default SvgComponent;
